<template>
  <div>
    <div class="content">
      <button
        class="button is-primary"
        :class="isLoading ? 'is-loading' : ''"
        @click="refreshprompts"
      >
        refresh images
      </button>
    </div>
    <div v-if="imagePrompts && imagePrompts.length != 0">
      <div
        class="lines"
        v-for="(imagePrompt, index) in imagePrompts"
        :key="index"
      >
        <div class="prompt">
          <p class="is-size-7">
            {{ new Date(imagePrompt.timestamp).toLocaleString() }}
          </p>
          <p v-html="imagePrompt.prompt"></p>

          <button
            class="button is-danger"
            @click="deleteImage(imagePrompt.image_id)"
          >
            delete&nbsp;id: {{ imagePrompt.image_id }}&nbsp;size:
            {{ imagePrompt.size }}
          </button>
        </div>
        <figure class="mini" @click="toggleImg">
          <img
            :src="`imagefolder/${imagePrompt.imagefilename}`"
            :title="imagePrompt.imagefilename"
            alt="An ai generated image"
          />
        </figure>
      </div>
    </div>
  </div>
</template>
<script>
import router from '@/router';
import { ref, inject, onMounted } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'ImagePrompts',

  setup(props) {
    const store = useStore();
    let isLoading = ref(false);

    const emitter = inject('emitter');
    const deleteEventName = 'deleteImage';

    emitter.on(`${deleteEventName}-yes`, async (image_id) => {
      await store.dispatch('delete', {
        end_point: 'imagePrompt',
        path_vars: {
          image_id,
        },
      });
      store.commit('deleteImage', { image_id });
      router.go();
    });
    emitter.on(`${deleteEventName}-no`, () => {});

    const deleteImage = async (image_id) => {
      store.dispatch('modal/setModal', {
        title: 'Weet je het zeker?',
        text: `Je staat op het punt om imagePrompt (${image_id}) te verwijderen`,
        eventName: deleteEventName,
        param: image_id,
        type: 'okcancel',
      });
    };

    const imagePrompts = ref([]);
    const refreshprompts = async () => {
      isLoading.value = true;
      imagePrompts.value = await store.dispatch('get', {
        end_point: 'imagePrompts',
      });
      isLoading.value = false;
    };
    onMounted(async () => {
      imagePrompts.value = await store.dispatch('get', {
        end_point: 'imagePrompts',
      });
    });
    const toggleImg = (event) => {
      const figureElement = event.currentTarget;
      figureElement.classList.toggle('mini');
      // Add your logic to toggle the image here
    };
    return {
      toggleImg,
      refreshprompts,
      isLoading,
      imagePrompts,
      deleteImage,
    };
  },
};
</script>
<style lang="scss">
.prompt {
  width: 100%;
  p {
    background-color: #f0f0f0;
    padding: 1 * $margin;
    margin-bottom: $margin;
  }
}
.lines {
  border: 1px solid gray;
  background-color: #f0f0f0;
  display: flex;
  justify-content: space-between;
  margin-bottom: $margin;
  padding: $margin;
}
</style>
